/**
 * Copyright (C) 2014-2017 Triumph LLC
 * 
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 * 
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 * 
 * You should have received a copy of the GNU General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
import register from "../util/register.js";

function Context(ns, exports) {

var _gl = null;

exports.setup = function(gl) {
    _gl = gl;
}

exports.get_gl = function() {
    return _gl;
}

exports.reset = function() {
    _gl = null;
}

}

var context_fact = register("__context", Context);

export default context_fact;


//////////////////
// WEBPACK FOOTER
// /home/nr/soft/blend4web_ce/src/intern/context.js
// module id = 66
// module chunks = 0